export default __webpack_public_path__ + "static/media/logo.18cbdd8e.svg";